exports.getAddress = function getAddress(contractName, networkName) {
    try {
        let addresses = {};
        if (networkName === 'localhost') {
            // uncomment for local development
            // addresses = require(`./localhost_addresses.json`);
        } else {
            addresses = require(`./addresses.json`);
        }
        return addresses[contractName][networkName].address;
    } catch (e) {
        const message = [
            `Could not read or parse ${contractName} on path [${contractName}][${networkName}]`,
            `You may need to deploy contracts to ${networkName}.`,
            `Here is the error message: ${e.message}`,
        ];
        if (networkName === 'localhost') {
            message.push(
                'To connect to a local hardhat network, 1stdibs-contracts must be linked with `yarn link ~/projects/1stdibs-contracts`, and `yarn hardhat node` must be running.'
            );
        }
        throw new Error(message.join('\n'));
    }
};
